import React from 'react';
import SidebarSection from './SidebarSection';

interface Stat {
    value: string | number | React.ReactNode;
    label: string;
}
interface SidebarStatsSectionProps {
    title: string;
    stats: Stat[];
}

/**
 * Renders a sidebar section containing labeled statistics.
 * @param props Section title and statistics to display.
 * @returns A translated sidebar statistics section.
 */
const SidebarStatsSection = ({ title, stats }: SidebarStatsSectionProps) => {
    return (
        <SidebarSection title={title}>
            <ul className='sidebar__stats-container'>
                {stats.map((stat, index) => (
                    <li key={index} className='sidebar__stat-item'>
                        <div className='sidebar__stat-value'>{stat.value}</div>
                        <div className='sidebar__stat-title'>{stat.label}</div>
                    </li>
                ))}
            </ul>
        </SidebarSection>
    );
};

export default SidebarStatsSection;
